var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1023,
    height: 1558,
    viewBox: "0 0 1023 1558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -349.25,
    y: -127.875,
    width: 1925,
    height: 2421.38,
    fill: "#FFD5FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -349.25,
    y: -127.875,
    width: 1925,
    height: 2421.38,
    fill: "url(#paint0_linear_935_2136)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1009.25 249.274C-303.371 612.628 887.991 934.592 6.40374 -684.39L-285.597 -1084.88C102.891 -724.68 966.704 -87.2298 1314.06 -418.988C1334.37 -464.009 1362.81 -580.118 1314.06 -684.39C1253.12 -814.729 1184.56 -1144.12 2583.62 -523.255",
    stroke: "#F51237",
    strokeWidth: 705.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2510.79 162.59C2162.85 -87.126 990.236 -1015.08 662.745 -400.181C538.849 -39.64 919.802 139.164 903.088 240.305C826.008 706.718 430.684 675.209 -652.152 380.717",
    stroke: "#FF5E71",
    strokeWidth: 521.026
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_2136",
    x1: 613.25,
    y1: -127.875,
    x2: 614.001,
    y2: 2193.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402658,
    stopColor: "#FFD5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735938,
    stopColor: "#FFF3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header-bg.802a0702bf5736a88107a41a3cdf342c.svg";
export { ForwardRef as ReactComponent };